module.exports = require('./helpers/bundle-url').getBundleURL('6xKsm') + "logo.c51670a8.svg";